// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__OmHyM","noInteraction":"EventWrapper_noInteraction__1zRkM","pointerPassthrough":"EventWrapper_pointerPassthrough__10h19"};